import type { CommonImageItemType } from '@/components-biz/ImageSelect';
import type { AppPlazaListItem } from '@/pages/data-center/app-center/app-plaza/types';

/** 将应用广场列表项映射为容器镜像选择器可用的 CommonImageItemType */
export function appPlazaItemToContainerImage(item: AppPlazaListItem): CommonImageItemType {
  const id = String(item.id || '').trim();
  const abstractId = String(item.parentArtifactId || item.abstractId || '').trim();
  const containerDeployConfig =
    item.containerDeployConfig ||
    (typeof item.options?.containerDeployConfig === 'string' ? item.options.containerDeployConfig : undefined);

  return {
    id,
    abstractId,
    key: id,
    workspace: item.workspace || '',
    artifactType: 'ai_application',
    vendor: item.vendor || '',
    name: item.name || '',
    version: item.version || '',
    description: item.description || '',
    kernelVersion: item.kernelVersion || '',
    cloudinitVersion: '',
    tag: item.tag || [],
    visibility: item.visibility || '',
    tenantAclWorkspaces: (item.tenantAclWorkspaces || []).map((entry) => (typeof entry === 'string' ? entry : String(entry?.name || ''))),
    status: item.status || '',
    formation: item.formation || '',
    cpuCompatibility: item.cpuCompatibility || '',
    cpuArchitectures: item.cpuArchitectures || [],
    hardwareCompatibility: '',
    hardwareConfig: [],
    httpSourceUrl: item.httpSourceUrl || '',
    httpSourceMd5: '',
    httpSourceSize: item.httpSourceSize || '',
    httpRefUrl: item.httpRefUrl || '',
    dockerSourceUrl: item.dockerSourceUrl || '',
    dockerSourceMd5: '',
    dockerSourceSize: item.dockerSourceSize || '',
    dockerRefUrl: item.dockerRefUrl || '',
    gitSourceUrl: '',
    gitSourceMd5: '',
    gitSourceSize: '',
    gitRefUrl: item.gitRefUrl || '',
    options: item.options || {},
    creator: item.creator || '',
    installScript: '',
    containerDeployConfig,
    fileName: item.fileName || '',
    createTime: item.createTime || '',
    updateTime: item.updateTime || '',
  };
}

/** 当前选中镜像 key 是否与应用广场项匹配 */
export function isAppPlazaImageMatch(item: AppPlazaListItem, selectedKey?: string) {
  const key = String(selectedKey || '').trim();
  if (!key) return false;
  const id = String(item.id || '').trim();
  const abstractId = String(item.parentArtifactId || item.abstractId || '').trim();
  return key === id || key === abstractId;
}
